import Button from '@ui/components/Button/Button'
import Icon from '@ui/components/Icon/Icon'

import styles from './WatchingStateSection.module.scss'

type WatchingStateSectionProps = {
	folderName: string
	syncedCount: number
	onStopWatching: () => void
}

const WatchingStateSection = ( { folderName, syncedCount, onStopWatching }: WatchingStateSectionProps ) => (
	<div className={styles.WatchingStateSection}>
		<div className={styles.WatchingStateSection__info}>
			<Icon icon="folder-outlined" size={14} color="primary" />
			<div className={styles.WatchingStateSection__text}>
				<span className={styles.WatchingStateSection__folderName}>{folderName}</span>
				<span className={styles.WatchingStateSection__status}>
					{syncedCount === 0
						? 'Watching for new files\u2026'
						: `${syncedCount} file${syncedCount === 1 ? '' : 's'} synced this session`}
				</span>
				<span className={styles.WatchingStateSection__hint}>
					Sync runs while this tab is open
				</span>
			</div>
		</div>
		<Button size="xs" variant="outline" onClick={onStopWatching}>
			Stop watching
		</Button>
	</div>
)

export default WatchingStateSection
